import {createContext} from 'react';
export const UserRoom = createContext(null);
export const Theme = createContext(null);
export const filePathMovie = createContext(null);
export const filePathSub = createContext(null);